<template>
  <div class="container _container">
    <MainTop :titlename="$i18n.locale=='zh_HK'?title[0]:titleEn[0]"
             :textContent="$i18n.locale=='zh_HK'?titleDescribe[0]:titleDescribeEn[0]"
             :imgsrc="getimgsrc(titleImg[0])"/>
    <Company :titlename="$i18n.locale=='zh_HK'?title[1]:titleEn[1]"
             :textContent="$i18n.locale=='zh_HK'?titleDescribe[1]:titleDescribeEn[1]"
             :imgsrc="getimgsrc(titleImg[1])"/>
    <CorporateDuty :titlename="$i18n.locale=='zh_HK'?title[2]:titleEn[2]"
                   :textContent="$i18n.locale=='zh_HK'?titleDescribe[2]:titleDescribeEn[2]"
                   />
    <div v-for="(item,index) in list">
      <ComIntroduction v-show="index>2"  :titlename="$i18n.locale=='zh_HK'?item.title:item.titleEn"
      :listInt="item.list"/>
      <div style="padding: 4% 0 0 0" v-show="index>2 && index< list.length-1">
        <hr  align="center"  width="60%" style="border:1px solid #898989;color: #898989;margin: 0 auto;">
      </div>
    </div>
    <Footer/>
<!--    <ComIntroduction :titlename="'Well-Being of People'"/>-->
<!--    <ComIntroduction :titlename="'Environmental Conservation'"/>-->
  </div>
</template>
<script>
  import MainTop from '@/views/comcomponents/MainTop'
  import Company from "./aboutcomponents/company";
  import CorporateDuty from "./aboutcomponents/corporateDuty";
  import ComIntroduction from "./aboutcomponents/comIntroduction";
  import Footer from "@/views/comcomponents/Footer"
  import {getListAbout} from '@/api/home';

  export default {
    name: 'About',
    components: {
      MainTop,
      Company,
      CorporateDuty,
      ComIntroduction,
      Footer
    },
    data(){
      return{
        list:'',
        title:[],
        titleEn:[],
        titleDescribe:[],
        titleDescribeEn:[],
        titleImg:[],
      }
    },
    created() {
      this.getListAbout();
    },
    methods: {
      getListAbout() {
        getListAbout() .then(response => {
          const data = response.data;
          this.list=data.data;
          this.list.forEach((item, index) => {
            this.title.push(item.title);
            this.titleEn.push(item.titleEn);
            this.titleDescribe.push(item.titleDescribe);
            this.titleDescribeEn.push(item.titleDescribeEn);
            this.titleImg.push(item.titleImg);
          });
        })
      },
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px){
    .container{
      font-size: 1vw;
      .subdiv{
        width: 100%;
        display: flex;
        justify-content: space-around;
        font-size: .5em;
        .left{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px){
    ._container{
      font-size: 1.5vw;
      ._subdiv{
        width: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        font-size: .5em;
        .left{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About/About.vue